import {combineReducers} from '@reduxjs/toolkit';

import {rolesGrantsResourcesStateSlice} from './slices/roles-grants-resources-state.slice';
import {rolesGrantsResourcesSlice} from './slices/roles-grants-resources.slice';

export const rolesGrantsResourcesReducer = combineReducers({
    rolesGrantsResources: rolesGrantsResourcesSlice.reducer,
    rolesGrantsResourcesState: rolesGrantsResourcesStateSlice.reducer,
});
